import * as React from 'react';
import { FormProvider, FormData, FilterOptions } from "../context/Form";
import { Segments } from './Segments';
import { DateRanges } from './DateRanges';
import { ChartDataContext, ChartDataProvider } from "../context/Chart";
import { Charts } from "./Charts";
import { ChartRefsDataProvider } from "../context/ChartRefs";
import { PdfDownloadButton } from "./PdfDownloadButton";
import { ExcelDownloadButton } from "./ExcelDownloadButton";

type PersonaScanStatsProps = {
    formdata: FormData;
    filteroptions: FilterOptions;
    ajaxUrl: string;
    nonce:string;
    scanId:string;
};

const ReloadChartDataButton = () => {
    const [data, dispatch] = React.useContext(ChartDataContext);

    const reloadChartData = () => {
        dispatch(
            {
                type: 'FETCH',
                payload: {},
            }
        );
    };

    if(data.fetching) {
        return <></>
    }

    return <button className={'c-segments__get-chartdata'} onClick={reloadChartData}>Filters toepassen</button>
}

export const PersonaScanStats = (props: PersonaScanStatsProps): JSX.Element => {

    return <FormProvider data={props.formdata} filteroptions={props.filteroptions} ajaxUrl={props.ajaxUrl}>
        <ChartDataProvider ajaxUrl={props.ajaxUrl} scanId={props.scanId}>
            <ExcelDownloadButton nonce={props.nonce} ajaxUrl={props.ajaxUrl} />
            <div className={'c-rstats-form'}>
                <Segments/>
                { !props.formdata.stages && <DateRanges/> }
                <ReloadChartDataButton/>
            </div>
            <ChartRefsDataProvider ajaxUrl={props.ajaxUrl} nonce={props.nonce}>
                <Charts/>
            </ChartRefsDataProvider>
        </ChartDataProvider>
    </FormProvider>;
}


